import { useUserQuery } from 'generated/graphql';

type PartialUserData = {
  alias?: string;
  email?: string;
  groups?: string[];
};
/**
 * Gets the user data from the GraphQL client cache. This call does not incur an additional network request.
 * @returns UserQuery user fields when a user is set. Otherwise returns an empty object.
 */
export const useUserData: () => PartialUserData = () => {
  const { data: userData } = useUserQuery();
  return userData?.user ?? {};
};
